import type { LookupApiModel } from '@esp/lookup/types-lookup';

const ACTION_SCOPE = '[Lookups]';
export namespace LookupsActions {
  export class Load {
    static readonly type = `${ACTION_SCOPE} Load Lookup`;

    constructor(public type: keyof LookupApiModel) {}
  }

  export class LoadAll {
    static readonly type = `${ACTION_SCOPE} Load All Lookups`;
  }

  export class ClearAll {
    static readonly type = `${ACTION_SCOPE} Clear All Lookups`;
  }

  export class ReloadTagTypes {
    static readonly type = `${ACTION_SCOPE} Reload Tag Types`;
  }

  export class ReloadRelationships {
    static readonly type = `${ACTION_SCOPE} Reload Relationships`;
  }
}
